import { PermissionName } from '@utmost.co/enterprise-models';
import { EngagementNavItem, ENGAGEMENTS_TAB, PATH_SCHEMA, SupportedFlags } from './EngagementsHome.constants';

export const navItems: EngagementNavItem[] = [
  getDefaults(ENGAGEMENTS_TAB.GENERAL, 'SETTINGS_ENGAGEMENTS'),
  getDefaults(ENGAGEMENTS_TAB.JOB_CATALOGUES, 'JOB_PROFILE'),
  getDefaults(ENGAGEMENTS_TAB.RATE_CARDS, 'RATE_CARD'),
  getDefaults(ENGAGEMENTS_TAB.TERMINATION_REASONS, 'REFERENCE_DATA'),
  getDefaults(ENGAGEMENTS_TAB.GENDER, 'REFERENCE_DATA')
];

function getDefaults(
  tab: ENGAGEMENTS_TAB,
  staticPermission?: PermissionName,
  flag?: SupportedFlags
): EngagementNavItem {
  return {
    label: `engagements.${tab}`,
    path: tab,
    pathSchema: `/:tenantCode${PATH_SCHEMA}/${tab}`,
    'data-test': `${tab}__settings__tab`,
    permissions: staticPermission ? [{ name: staticPermission, action: 'READ' }] : [],
    flag
  };
}
